'use strict';

angular.module('bringgApp').factory('TaskNote', function ($resource, WEB_API_URL) {
	var TaskNote = $resource(WEB_API_URL + '/tasks/:task_id/way_points/:way_point_id/task_notes', { id: '@id' }, {});
	return TaskNote;
});
